import React from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HeroCarousel from './components/HeroCarousel';
import Hero from "./components/Hero";
import About from "./components/About";
import Collage from './components/Collage';
import Services from "./components/Services";
import Clients from "./components/Clients";
import Marcas from "./components/Marcas";
import Location from "./components/Location";
import SuggestionButton from "./components/SuggestionButton";

function App() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <HeroCarousel />
        <Hero />
        <About />
        <Collage />
        <Services />
        <Clients />
        <Marcas />
        <Location />
        <SuggestionButton />
      </main>
      <Footer />
    </div>
  );
}

export default App;
